import { PERMISSIONS, ROUTE_PATHS } from "./../PermissionsConstants";
import {
  BuildingOfficeIcon,
  IdentificationIcon,
  NewspaperIcon,
  PresentationChartLineIcon,
  PrinterIcon,
  QrCodeIcon,
  RectangleStackIcon,
  TicketIcon,
  UsersIcon,
} from "@heroicons/react/24/solid";
import CarrierAgreementReports from "../CarrierAgreementMgmt/Reports/AgreementReports/CarrierAgreementReports";
import OfficeReports from "../CarrierAgreementMgmt/Reports/OfficeReports";
import EmployeeReports from "../CarrierAgreementMgmt/Reports/EmployeeReports";
import { DigitalAssetsReport } from "../CarrierAgreementMgmt/Reports/DigitalAssetReport/DigitalAssetsReport";
import { LeasedEquipmentReport } from "../CarrierAgreementMgmt/Reports/LeasedEquipmentReport/LeasedEquipmentReport";
import ScorecardReport from "../CarrierAgreementMgmt/Reports/ScorecardReport";
import BusLicensePermitsReport from "../CarrierAgreementMgmt/Reports/BusinessLicensesPermitsReport";
import ProducerCodeReports from "../CarrierAgreementMgmt/Reports/ProducerCodeReports";
import CarrierReport from "modules/CarrierAgreementMgmt/Reports/CarrierReport";
import {
  EMPLOYEEREPORTS_PERMISSIONS,
  EMPLOYEEREPORTS_ROUTEPATHS,
} from "modules/CarrierAgreementMgmt/Reports/EmployeeReports/permission";

export const ReportsTabs = [
  {
    to: ROUTE_PATHS.CSOPC_Reports_Index,
    component: ProducerCodeReports,
    label: "Producer Code",
    icon: <QrCodeIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_report_producercode_view,
  },
  {
    to: ROUTE_PATHS.Carrier_Reports_Index,
    component: CarrierReport,
    label: "Carrier",
    icon: <RectangleStackIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_report_carrier_view,
  },
  {
    to: ROUTE_PATHS.CarrierAgreement_Reports_Index,
    component: CarrierAgreementReports,
    label: "Agreement",
    icon: <NewspaperIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_agreement_reports_view,
  },
  {
    to: ROUTE_PATHS.Reports_Office_Index,
    component: OfficeReports,
    label: "Office",
    icon: <BuildingOfficeIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_report_office_view,
  },
  {
    to: EMPLOYEEREPORTS_ROUTEPATHS.Reports_Employee_Index,
    component: EmployeeReports,
    label: "Employee",
    icon: <UsersIcon className="h-4 w-4 mr-2" />,
    permission: EMPLOYEEREPORTS_PERMISSIONS.permission_report_employees_view,
  },
  {
    to: ROUTE_PATHS.DigitalAsset_Report_Index,
    component: DigitalAssetsReport,
    label: "Marketing/Digital Assets",
    icon: <PresentationChartLineIcon className="h-4 w-4 mr-2" />,
    permission:
      PERMISSIONS.permission_report_digitalasset_digitalassetsreport_view,
  },
  {
    to: ROUTE_PATHS.LeasedEquipment_Report_Index,
    component: LeasedEquipmentReport,
    label: "Leased Equipment",
    icon: <PrinterIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_leasedequipment_reports_view,
  },
  {
    to: ROUTE_PATHS.Reports_Scorecard_Index,
    component: ScorecardReport,
    label: "Scorecard",
    icon: <TicketIcon className="h-4 w-4 mr-2" />,
    permission: PERMISSIONS.permission_report_scorecard__view,
  },
  {
    to: ROUTE_PATHS.Reports_BLP_Index,
    component: BusLicensePermitsReport,
    label: "Business Licenses and Permits",
    icon: <IdentificationIcon className="h-4 w-4 mr-2" />,
    permission:
      PERMISSIONS.permission_report_businesslicensepermit_businesslicensespermitreports_view,
  },
];
